import { Box, Flex, Grid, SystemProps, Text } from "@storyofams/react-ui";
import _ from "lodash";
import styled from "styled-components";
interface InfoListProps extends SystemProps {
  content: {
    [key: string]: string;
  };
}

export const InfoList = ({ content, ...props }: InfoListProps) => {
  const messages = {
    PrepTime: "Voorbereiding",
    TotalTime: "Totale tijd",
    yeld: "Recept per:",
    Niveau: "Niveau",
    Houdbaarheid: "Houdbaarheid",
  };
  const InfoGrid = styled(Flex)`
    background-color: #fcf9f7;
    border: 1px solid #e2dfdf;
    border-radius: 8px;
  `;
  const result = _.pick(content, [
    "PrepTime",
    "TotalTime",
    "yeld",
    "Niveau",
    "Houdbaarheid",
  ]);
  const info = () => {
    return Object.keys(result).map((key, i) => {
      let description;
      switch (key) {
        case "PrepTime":
        case "TotalTime":
          description = result[key] + " min.";
          break;
        case "PricePerPortion":
          description = "€" + result[key];
          break;
        case "Houdbaarheid":
          if (!result[key]) description = "";
          else description = result[key] + " maanden";
          break;
        default:
          description = result[key];
      }
      return (
        <Box
          key={i}
          mt={[i && 1, 0]}
          width={["100%", "max-content"]}
          display="flex"
          flexDirection={["row", "column"]}
        >
          <Text
            lineHeight={"19.6px"}
            width={["130px", "max-content"]}
            fontSize={"14px"}
            fontWeight={[600, "bold"]}
          >
            {messages[key]}
          </Text>
          <Text lineHeight={"19.6px"} color="#1D1D1BCC" fontSize={"14px"}>
            {description}{" "}
            {messages[key] === "Recept per:" && `(${content.recipe_price_uom})`}
          </Text>
        </Box>
      );
    });
  };

  return (
    <InfoGrid
      px={["16px", "12px"]}
      py={["16px", "12px"]}
      flexWrap={"wrap"}
      justifyContent={"space-between"}
      // justifyContent="space-between"
      flexDirection={["column", "row"]}
      {...props}
    >
      {info()}
    </InfoGrid>
  );
};
